import fetch from '@/apiconfig/index';

export function getImage() {
  return fetch({
    url: '/api/companystaff/employeeAccount/getChinessImage',
    method: 'get',
    responseType: 'blob',
    emulateJSON: true
  });
}
export function getImage2() {
  return fetch({
    url: '/api/companystaff/employeeAccount/getChinessImage2',
    method: 'get',
    responseType: 'blob',
    emulateJSON: true
  });
}